var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { action, computed, makeObservable, observable, override } from 'mobx';
import { ElementSerializer } from 'lib/graphEditor/ElementSerializer';
import { BaseElementModel } from './BaseElementModel';
export class ActionElementModel extends BaseElementModel {
    constructor(params = {}) {
        super(Object.assign(Object.assign({}, params), { attributes: {
                content: {
                    name: 'content',
                    defaultValue: '',
                    type: 'string',
                },
                invisible: {
                    name: 'invisible',
                    defaultValue: false,
                    type: 'boolean',
                },
                backgroundColor: {
                    name: 'backgroundColor',
                    defaultValue: '',
                    type: 'color',
                },
            } }));
        Object.defineProperty(this, "triggeredStateExpression", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        makeObservable(this);
        this.type = ActionElementModel.typename;
    }
    get content() {
        return this.attributes.values.content;
    }
    get invisible() {
        return this.attributes.values.invisible;
    }
    setContent(value) {
        this.attributes.setAttributeValue('content', value);
    }
    setTriggeredStateExpression(expression) {
        this.triggeredStateExpression = expression;
    }
    get readableTitle() {
        return this.content;
    }
    getEncodableData() {
        return Object.assign(Object.assign({}, super.getEncodableData()), { triggeredStateExpression: this.triggeredStateExpression });
    }
    deserialize(input) {
        super.deserialize(input);
        this.triggeredStateExpression = input.triggeredStateExpression;
    }
    copy() {
        const i = super.copy();
        i.triggeredStateExpression = this.triggeredStateExpression;
        return i;
    }
}
Object.defineProperty(ActionElementModel, "typename", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 'action'
});
Object.defineProperty(ActionElementModel, "descriptor", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: ({ t }) => ({
        title: t('libGraphEditor:contentBuilder.actionElement.title', 'Action'),
    })
});
Object.defineProperty(ActionElementModel, "decode", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: (val) => {
        const i = new ActionElementModel();
        i.deserialize(val);
        return i;
    }
});
__decorate([
    observable,
    __metadata("design:type", String)
], ActionElementModel.prototype, "triggeredStateExpression", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], ActionElementModel.prototype, "setTriggeredStateExpression", null);
__decorate([
    computed({ keepAlive: true }),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], ActionElementModel.prototype, "readableTitle", null);
__decorate([
    override,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [typeof (_a = typeof ReturnType !== "undefined" && ReturnType) === "function" ? _a : Object]),
    __metadata("design:returntype", void 0)
], ActionElementModel.prototype, "deserialize", null);
__decorate([
    override,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], ActionElementModel.prototype, "copy", null);
ElementSerializer.register(ActionElementModel, 'ActionElementModel');
